export default function Card({ children, className, backgroundColor = 'bg-white', ...rest }) {
  return (
    <div
      className={`${className} ${backgroundColor} w-full p-3 rounded-md shadow-md border`}
      {...rest}
    >
      {children}
    </div>
  );
}
